import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { Tab } from '@headlessui/react';
import { ReactElement } from 'react';

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

const HorizontalTabs = ({
  tabs,
  position,
  setChangedTabIndex,
}: {
  tabs: { [tabName: string]: JSX.Element };
  position?: 'center' | 'end' | 'start';
  setChangedTabIndex?: (index: number) => void;
}) => {
  return (
    <div className="w-full  sm:px-0">
      <Tab.Group
        onChange={(index: number) =>
          setChangedTabIndex && setChangedTabIndex(index)
        }
      >
        <Tab.List className="flex space-s-1 justify-center w-full  p-1">
          {Object.keys(tabs).map((tab) => (
            <Tab
              key={tab}
              className={({ selected }) =>
                classNames(
                  'w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-primary',
                  'ring-white ring-opacity-60 ring-offset-2 ring-offset-primary-light focus:outline-none ',
                  selected
                    ? ' bg-ring-color shadow'
                    : 't hover:bg-white/[0.12] hover:text-primary-light'
                )
              }
            >
              <ReturnTranslatedText origintext={tab} text={`general.${tab}`} />
            </Tab>
          ))}
        </Tab.List>
        <Tab.Panels className="mt-2">
          {Object.values(tabs).map((tabContent, idx) => (
            <Tab.Panel key={idx} className={classNames()}>
              {tabContent}
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
};

export default HorizontalTabs;
